import { StatusType, StyledColor } from './types'

export function getBorderLeft(color?: StyledColor) {
  switch (color) {
    case 'red':
      return 'border-l-[8px] border-l-statusred-500'
    case 'amber':
      return 'border-l-[8px] border-l-brandorange-500'
    case 'yellow':
      return 'border-l-[8px] border-l-statusyellow-500'
    case 'green':
      return 'border-l-[8px] border-l-statusgreen-500'
    case 'blue':
      return 'border-l-[8px] border-l-statusblue-500'
    case 'grey':
      return 'border-l-[8px] border-l-neutral-500'
    default:
      return ''
  }
}

export function getIconColor(color?: StyledColor) {
  switch (color) {
    case 'red':
      return 'bg-statusred-500'
    case 'amber':
      return 'bg-brandorange-500'
    case 'yellow':
      return 'bg-statusyellow-500'
    case 'green':
      return 'bg-statusgreen-500'
    case 'blue':
      return 'bg-statusblue-500'
    case 'grey':
      return 'bg-neutral-500'
    default:
      return 'bg-neutral-500'
  }
}

export function getBadgeColor(color?: StatusType) {
  switch (color) {
    case 'error':
      return 'bg-statusred-50 text-statusred-500 border border-statusred-300'
    case 'warning':
      return 'bg-statusyellow-50 text-statusyellow-500 border border-statusyellow-300'
    case 'success':
      return 'bg-statusgreen-50 text-statusgreen-500 border border-statusgreen-300'
    case 'info':
      return 'bg-statusblue-50 text-statusblue-500 border border-statusblue-300'
    default:
      return 'bg-neutral-50 text-neutral-500 border border-neutral-300'
  }
}

export function getStatusColor(color?: StatusType) {
  switch (color) {
    case 'error':
      return 'text-statusred-500'
    case 'warning':
      return 'text-statusyellow-500'
    case 'success':
      return 'text-statusgreen-500'
    case 'info':
      return 'text-statusblue-500'
    default:
      return 'text-neutral-500'
  }
}
